import { all, fork, put, takeEvery, takeLatest, call, delay } from "redux-saga/effects"

import {
  END_DAY_PREVIEW,
  END_DAY_RUN,
  END_DAY_REALTIME_UPDATE
} from "constants/ActionTypes"

import {
  endDayDataSourceUpdate,
  endDayProcessSuccess,
  endDayProcessReset
} from "appRedux/actions/nightAudit/endDay"
import { userSignOut } from "appRedux/actions/Auth"

import { API_URL_V1, API_PMS_HEADERS } from "constants/ApiSetting"
import { APIGetRequest, APIPostRequest } from "util/connection"
import { getItems } from "util/localStorage"

function* endDayPreviewProcess() {

  const { access_token } = yield call(getItems, ['access_token'])
  const AccessToken = access_token
  const url = `${API_URL_V1}pms/nightAudit/endday/`
  API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

  try {
    const response = yield APIGetRequest(url, API_PMS_HEADERS)
    if (response.status === 200) {
      const { status, start_time, finish_time, tasks } = response.data
      const endDayInfo = { status, start_time, finish_time, tasks }
      /* if no error put everything to reducer */
      yield put(endDayDataSourceUpdate(endDayInfo))
      yield delay(100)

    } else {
      /* Show error message and signout */
      const { message, data } = response.data
      const processStatus = { status: false, action: "preview", message }
      yield put(endDayProcessSuccess(processStatus))
      yield delay(100)
      yield put(endDayProcessReset())
      yield delay(100)
      if (response.status === 403) {
        /* if data is not null force signout */
        if (data)
          yield put(userSignOut())
      }

    }
  } catch (error) {
    const processStatus = { status: false, action: "preview", message: error }
    yield put(endDayProcessSuccess(processStatus))
    yield delay(100)
    yield put(endDayProcessReset())
    yield delay(100)
  }

}

function* endDayRunProcess() {
  try {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/nightAudit/endday/execute/`

    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

    const response = yield APIPostRequest(url, {}, { ...API_PMS_HEADERS, timeout: 300000 },) // 5 minutes timeout

    if (response.status === 200) {
      /* Code something true */
      const { status, start_time, finish_time, tasks } = response.data
      const endDayInfo = { status, start_time, finish_time, tasks }
      yield put(endDayDataSourceUpdate(endDayInfo))
      yield delay(100)
    } else if (response.status === 403) {
      const { message, data } = response.data
      const processStatus = { status: false, action: "execute", message }
      yield put(endDayProcessSuccess(processStatus))
      yield delay(100)
      yield put(endDayProcessReset())
      yield delay(100)
      /* if data is not null force signout */
      if (data) yield put(userSignOut())
    } else if (response.status === 408 || response.status === 504 || response.status === 524) {
      // HTTP timeout — server may still be running End Day.
      // SignalR is the source of truth; do nothing here.
    } else {
      // Network error / proxy cut the connection — End Day may still be running on the server.
      // SignalR is the source of truth for progress. Do NOT fire an error modal here.
      console.warn('[EndDay] HTTP connection lost during execute (status:', response.status, '). SignalR will track progress.')
    }

  } catch (error) {
    const status = error?.response?.status
    if (status === 408 || status === 504 || status === 524) {
      // Timeout — SignalR will track progress.
      return
    }
    console.warn('[EndDay] HTTP exception during execute:', error, '— SignalR will track progress.')
  }
}

function* endDayRealTimeUpdateProcess({ payload }) {
}

/* Watcher Saga */
export function* endDayPreview() {
  yield takeLatest(END_DAY_PREVIEW, endDayPreviewProcess)
}
export function* endDayRun() {
  yield takeEvery(END_DAY_RUN, endDayRunProcess)
}
export function* endDayRealTimeUpdate() {
  yield takeEvery(END_DAY_REALTIME_UPDATE, endDayRealTimeUpdateProcess)
}

export default function* rootSaga() {
  yield all([fork(endDayPreview),
  fork(endDayRun),
  fork(endDayRealTimeUpdate)])


}
